import { StrictMode } from 'react';
import './index.css';
import './i18n';
import App from './App.tsx';
import { bootstrap } from '@gokrew/ui';
import { DialogProvider } from '@gokrew/ui/context';
import { Toaster } from 'react-hot-toast';
import { AppConfigProvider } from '@gokrew/ui/context';
import { AuthProvider } from './context/AuthContext.tsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const app = (
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppConfigProvider>
        <AuthProvider>
          <DialogProvider>
            <Toaster position="top-right" reverseOrder={false} />
            <App />
          </DialogProvider>
        </AuthProvider>
      </AppConfigProvider>
    </QueryClientProvider>
  </StrictMode>
);

bootstrap('root', app);
